import { useSessionTyped } from '@dreamstack/auth'
import { useLocale } from '@dreamstack/i18n'
import { trpc } from '@dreamstack/trpc/client'

export const useDeleteFavoriteOptimistic = () => {
  const locale = useLocale()
  const utils = trpc.useUtils()
  const { mutateAsync: deleteFavorite } =
    trpc.favorites.deleteFavorite.useMutation({
      onMutate: async ({ propertyId }) => {
        await utils.favorites.getMyFavorites.cancel({ locale })
        const previousFavorites = utils.favorites.getMyFavorites.getData({
          locale,
        })
        utils.favorites.getMyFavorites.setData({ locale }, (old) =>
          old?.filter((f) => f.propertyId !== propertyId) ?? []
        )
        return { previousFavorites }
      },
      onError: (_err, _deletedFavorite, context) => {
        if (context?.previousFavorites) {
          utils.favorites.getMyFavorites.setData(
            { locale },
            context.previousFavorites
          )
        }
      },
      onSettled: () => {
        utils.favorites.getMyFavorites.invalidate({ locale })
      },
    })

  return deleteFavorite
}

export const useAddFavoriteOptimistic = () => {
  const locale = useLocale()
  const utils = trpc.useUtils()
  const session = useSessionTyped()
  const { mutateAsync: addFavorite } =
    trpc.favorites.upsertFavorite.useMutation({
      onMutate: async ({ propertyId, note }) => {
        await utils.favorites.getMyFavorites.cancel({ locale })
        const previousFavorites = utils.favorites.getMyFavorites.getData({
          locale,
        })
        utils.favorites.getMyFavorites.setData({ locale }, (old) => [
          ...(old ?? []),
          {
            propertyId,
            userId: session?.id ?? '',
            note: note ?? null,
            createdAt: new Date(),
            property: {
              id: propertyId,
            },
          } as any,
        ])
        return { previousFavorites }
      },
      onError: (_err, _newFavorite, context) => {
        if (context?.previousFavorites) {
          utils.favorites.getMyFavorites.setData(
            { locale },
            context.previousFavorites
          )
        }
      },
      onSettled: () => {
        utils.favorites.getMyFavorites.invalidate({ locale })
      },
    })

  return addFavorite
}

